export default "__VITE_ASSET__D8T_tnB1__"